import IconFeature1 from '/public/icons/icon-estate-feature-1.svg'
import IconFeature2 from '/public/icons/icon-estate-feature-2.svg'
import IconFeature3 from '/public/icons/icon-estate-feature-3.svg'
import IconFeature4 from '/public/icons/icon-estate-feature-4.svg'
import IconFeature5 from '/public/icons/icon-estate-feature-5.svg'

const data = [
  {
    icon: <IconFeature1 />,
    title: 'Unrivaled marketing',
    description:
      'When you list you want your property to rise to the top. We can make that happen.'
  },
  {
    icon: <IconFeature2 />,
    title: 'Exclusive partnerships',
    description:
      'We’re able to amplify your listing through our strategic and exclusive partnerships. That means more eyes on your property.'
  },
  {
    icon: <IconFeature3 />,
    title: 'Brand reputation',
    description:
      'Sotheby’s International Realty opens doors for your listing that’s unmatched by other agencies'
  },
  {
    icon: <IconFeature4 />,
    title: 'True global reach',
    description:
      'Your listing will be accessible throughout the world and shown in its best light.'
  },
  {
    icon: <IconFeature5 />,
    title: 'PR powerhouse',
    description:
      'Offal freegan drinking vinegar jianbing wolf glossier +1 disrupt. DSA shaman jean shorts raw denim.'
  }
]

export default data
